module.exports = __webpack_public_path__ + "img/c683219.png";